module.exports = __webpack_public_path__ + "static/media/TI.f70570db.png";